import { render } from "./App.vue?vue&type=template&id=104908c7"
const script = {}

import "./App.vue?vue&type=style&index=0&id=104908c7&lang=scss"

import exportComponent from "E:\\4-6 项目\\蚂蚁电能交易分析\\energy\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__